export default __webpack_public_path__ + "static/media/pencilIconDark.ea62cc8b.svg";